import { inboxComponent } from './inbox.component';
import { UserPermissions } from '../../common/user/user.roles';

export const inboxStateName = 'app.inbox';

export const inboxState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: inboxStateName,
    url: '/inbox',
    component: inboxComponent.name,
    data: { requiresAuth: true },
    resolve: {
      checkAccess: ($q, $state, featureFlagService, userService ) => {
        'ngInject';
        let deferred = $q.defer();
        const featureNewAndDoneDocuments = featureFlagService.isFeatureActive(featureFlagService.FeatureNames.FF_INBOX_FOR_NEW_AND_DONE_DOCUMENTS);
        const featureRejectedDocuments = featureFlagService.isFeatureActive(featureFlagService.FeatureNames.FF_INBOX_FOR_REJECTED_DOCUMENTS_WIHTOUT_IBAN);
        const permissionList = [UserPermissions.Inbox.newAndDoneDocuments, UserPermissions.Inbox.rejectedDocumentsWithoutIban];
        // user needs permission and tenant need to be enabled inbox feature
        const canAccessState = userService.hasPermission(permissionList)
          && (featureNewAndDoneDocuments || featureRejectedDocuments);

        if(canAccessState){
          deferred.resolve();
        } else {
          deferred.reject();
          $state.go('app.home');
        }

        return deferred.promise;
      }
    }
  });
};
